const getDefaultState = () => {
	return {
		promotion: [],
		promotion_form: {
			name: null,
			link: null,
			image: null,
			is_published: null,
		}
	}
}

const default_state = getDefaultState()

export { default_state }